export default "__VITE_ASSET__BfFPN3m1__"